import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import { XRayGeneratorStateContext } from 'app/providers/XRayGeneratorProvider';
import SettingsRow from '../SettingsRow';

/**
 * Renders the generator software version as a SettingsRow when available.
 * Returns null when version data is not present.
 * This is a "content" setting (manages its own SettingsRow) because
 * visibility depends on React context which can't be checked statically.
 */
export default function GeneratorSoftwareVersion() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const generatorState: any = useContext(XRayGeneratorStateContext);
  const softwareVersion = generatorState?.softwareVersion;
  const { version, major, minor } = softwareVersion ?? {};

  if (version === undefined) return null;

  return (
    <SettingsRow title={<FormattedMessage id="account.configuration.xray_generator.version" />}>
      {version}.{major}.{minor}
    </SettingsRow>
  );
}
